import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { reinitialiseAPI, getAPI, postAPI } from 'store/apiReducer';
import {
    ButtonGroup,
    Button,
    LoaderMi,
    Row,
    Col,
    Container,
    CardV2,
    CardBody,
    CardContent,
    ButtonLink,
} from '@si-armes/dsfr-react';
import { Link, useHistory } from 'react-router-dom';
import PropTypes, { shape } from 'prop-types';
import InformationsPersonneMoraleEtablissement from 'components/MetiersEtAssociations/InformationsPersonneMoraleEtablissement';
import usagerClientReducer from '../../../../store/usagerReducer';
import formaterAdresseSecondaire from '../components/FormaterAdresseSecondaire';
import RoutesModifierPersonnePhysique from '../modification-personne-physique/routes';
import RoutesModifierResponsableLegal from '../modification-responsable-legal/routes';
import TableAdressesComponent from '../../../../components/table/TableAdressesComponent';
import InformationsPersonnelles from '../../../../components/informationsPersonnelles/InformationsPersonnelles';
import {
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    API_SUPPRIMER_ADRESSE_SECONDAIRE,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE,
} from '../../../../constants/apiUrls.constants';
import RoutesMonCompte from '../routes';
import RoutesAjoutAdresseSecondaire from '../ajouter-adresse-secondaire/routes';
import DisplayLicence from './components/DisplayLicence';
import TypeCompte from '../../../../components/Compte/TypeCompte';
import { getPath } from '../../../../utils/router';
import {
    FEATURE_APPEL_API_FFTIR,
    FEATURE_MFA_DETENTEUR_PREFECTURE,
    isFeatureActive,
} from '../../../../components/FeatureFlipping/featureFlipping.func';
import BoutonTelechargementFichier from '../../../../components/BoutonTelechargementFichier/BoutonTelechargementFichier';
import { isMetierPhysique } from '../../../../utils/Statuts.MetierAsso.constant';

const EcranGestion = ({
    reinitialiseApi,
    postApi,
    getApi,
    isLoading,
    dataCompteUsager,
    erreur,
    message,
    dataSuppression,
}) => {
    const URL_RATELIER = '/espace-detenteurs/ratelier';

    const history = useHistory();
    const { data: featureFlipping } = useSelector((state) => state.featureFlipping);
    const sousStatut = dataCompteUsager?.informationsMetiersAssociations?.sousStatut;
    const isMineurNonEmancipe = dataCompteUsager?.mineurEmancipe === false;
    const responsableLegal = dataCompteUsager?.responsableLegal;

    const recuperationInformations = () => {
        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );
        return () => {
            reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        };
    };

    useEffect(() => {
        recuperationInformations();
    }, []);

    useEffect(() => {
        if (dataSuppression) {
            recuperationInformations();
        }
    }, [dataSuppression]);

    if (isLoading) {
        return (
            <>
                <div className="loader-full-screen">
                    <LoaderMi taille="md" />
                </div>
            </>
        );
    }
    if (erreur) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>{message}</p>
            </div>
        );
    }
    if (!dataCompteUsager || !dataCompteUsager.compte || !dataCompteUsager.personnePhysique) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>Une erreur s&apos;est produite !</p>
            </div>
        );
    }

    const formatIdAdresse = (idAdresse) => {
        return {
            idAdresse,
        };
    };

    const suppressionAdresseSecondaire = (idAdresse, uniquidPersonnePhysique) => {
        postApi(
            usagerClientReducer,
            API_SUPPRIMER_ADRESSE_SECONDAIRE,
            { ...formatIdAdresse(idAdresse), uniquidPersonnePhysique },
            CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE,
        );
        return () => {
            reinitialiseApi(CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE);
        };
    };

    const getActionsAdressesSecondaires = (idAdresse, uniquidPersonnePhysique) => {
        return (
            <ButtonGroup inline align="center">
                <ButtonLink
                    as={Link}
                    to={{
                        pathname: getPath(RoutesMonCompte.subroutes.modifierAdresseSecondaire, {
                            idAdresse,
                        }),
                        state: { uniquidPersonnePhysique },
                    }}
                    icon="fr-fi-edit-fill"
                    variant="secondary"
                    title="Modifier l'adresse secondaire"
                />
                <Button
                    icon="fr-fi-delete-fill"
                    onClick={() => suppressionAdresseSecondaire(idAdresse, uniquidPersonnePhysique)}
                    variant="secondary"
                    title="Supprimer l'adresse secondaire"
                />
            </ButtonGroup>
        );
    };

    const getAdressesSecondaires = (personne = dataCompteUsager.personnePhysique) => {
        const { adressesSecondaires } = personne;
        const tableAdressesSecondaires = [];
        if (adressesSecondaires) {
            for (let i = 0; i < adressesSecondaires.length; i += 1) {
                tableAdressesSecondaires.push(formaterAdresseSecondaire(adressesSecondaires[i]));
            }
            return tableAdressesSecondaires;
        }
        return null;
    };

    const getIdAdressesSecondaires = (personne = dataCompteUsager.personnePhysique) => {
        const { adressesSecondaires } = personne;
        const listeIdAdresses = [];
        if (adressesSecondaires) {
            for (let i = 0; i < adressesSecondaires.length; i += 1) {
                listeIdAdresses.push(adressesSecondaires[i].id);
            }
            return listeIdAdresses;
        }
        return null;
    };

    const getActionsAdressePrincipale = (personne, uniquidPersonnePhysique) => {
        const personneCible = personne || dataCompteUsager.personnePhysique;
        return (
            <ButtonLink
                as={Link}
                to={{
                    pathname: getPath(RoutesMonCompte.subroutes.adressePrincipale, {
                        idAdresse: personneCible.adressePrincipale.id,
                    }),
                    state: { uniquidPersonnePhysique },
                }}
                icon="fr-fi-edit-fill"
                variant="secondary"
                title="Modifier l'adresse principale"
            />
        );
    };

    const getAdresse = (adresse) => {
        return [formaterAdresseSecondaire(adresse)];
    };

    const IS_ASSOCIATION_OU_METIER_PERSONNE_MORALE =
        dataCompteUsager.informationsMetiersAssociations &&
        dataCompteUsager.informationsMetiersAssociations.hasPersonneMorale;

    return (
        <Container fluid={false}>
            <Row>
                <Col col={12}>
                    <h1>Gestion de compte</h1>
                </Col>
            </Row>

            {IS_ASSOCIATION_OU_METIER_PERSONNE_MORALE && (
                <Row>
                    <Col col={12}>
                        <CardV2 noEnlargeLink>
                            <CardBody>
                                <CardContent>
                                    <Row gutters>
                                        <Col col={12} lg={4}>
                                            <h2>Informations personne morale</h2>
                                            <InformationsPersonneMoraleEtablissement
                                                informationsEtablissement={
                                                    dataCompteUsager.informationsMetiersAssociations
                                                        .etablissement
                                                }
                                                federation={
                                                    dataCompteUsager.informationsMetiersAssociations
                                                        .typeFederation
                                                }
                                                sousStatut={
                                                    dataCompteUsager.informationsMetiersAssociations
                                                        .sousStatut
                                                }
                                                typeMetier={
                                                    dataCompteUsager.informationsMetiersAssociations
                                                        .typeMetier
                                                }
                                            />
                                        </Col>
                                        <Col col={12} lg={8}>
                                            <h2>Adresse(s)</h2>
                                            <TableAdressesComponent
                                                labelTableau="Adresse principale"
                                                listeAdresses={getAdresse(
                                                    dataCompteUsager.informationsMetiersAssociations
                                                        .adresseEtablissement,
                                                )}
                                                actions={() => {}}
                                            />
                                        </Col>
                                    </Row>
                                </CardContent>
                            </CardBody>
                        </CardV2>
                    </Col>
                </Row>
            )}

            <Row className="margin-top-md">
                <Col col={12}>
                    <CardV2 noEnlargeLink>
                        <CardBody>
                            <CardContent>
                                <Row gutters>
                                    <Col col={12} lg={4}>
                                        <h2>
                                            {IS_ASSOCIATION_OU_METIER_PERSONNE_MORALE
                                                ? 'Informations du responsable légal'
                                                : 'Informations Personnelles'}
                                        </h2>
                                        <InformationsPersonnelles
                                            dataInformationsPersonnelles={
                                                dataCompteUsager.personnePhysique
                                            }
                                        />
                                    </Col>
                                    <Col col={12} lg={8}>
                                        <h2>Adresse(s)</h2>
                                        <TableAdressesComponent
                                            labelTableau="Adresse principale"
                                            listeAdresses={getAdresse(
                                                dataCompteUsager.personnePhysique.adressePrincipale,
                                            )}
                                            actions={() => getActionsAdressePrincipale()}
                                        />
                                        {!IS_ASSOCIATION_OU_METIER_PERSONNE_MORALE && (
                                            <TableAdressesComponent
                                                labelTableau="Adresse(s) secondaire(s)"
                                                listeAdresses={getAdressesSecondaires()}
                                                listeId={getIdAdressesSecondaires()}
                                                actions={(idAdresse) =>
                                                    getActionsAdressesSecondaires(idAdresse)
                                                }
                                            />
                                        )}
                                    </Col>
                                </Row>
                                <ButtonGroup equisized align="right" inline iconPosition="left">
                                    <Button
                                        name="modifierInformationsPersonnelles"
                                        variant="secondary"
                                        onClick={() => {
                                            history.push(getPath(RoutesModifierPersonnePhysique));
                                        }}
                                    >
                                        Modifier mes informations personnelles{' '}
                                    </Button>
                                    {!IS_ASSOCIATION_OU_METIER_PERSONNE_MORALE && (
                                        <Button
                                            name="ajouterAdresseSecondaire"
                                            onClick={() => {
                                                history.push(getPath(RoutesAjoutAdresseSecondaire));
                                            }}
                                            variant="secondary"
                                            icon="fr-icon-add-line"
                                            iconPosition="left"
                                        >
                                            Ajouter une adresse de résidence secondaire{' '}
                                        </Button>
                                    )}
                                </ButtonGroup>
                            </CardContent>
                        </CardBody>
                    </CardV2>
                </Col>
            </Row>

            {isMineurNonEmancipe && responsableLegal && (
                <Row className="margin-top-md">
                    <Col col={12}>
                        <CardV2 noEnlargeLink>
                            <CardBody>
                                <CardContent>
                                    <Row gutters>
                                        <Col col={12} lg={4}>
                                            <h2>Informations du responsable légal</h2>
                                            <InformationsPersonnelles
                                                dataInformationsPersonnelles={responsableLegal}
                                            />
                                        </Col>
                                        <Col col={12} lg={8}>
                                            <h2>Adresse(s)</h2>
                                            <TableAdressesComponent
                                                labelTableau="Adresse principale"
                                                listeAdresses={[
                                                    formaterAdresseSecondaire(
                                                        responsableLegal.adressePrincipale,
                                                    ),
                                                ]}
                                                actions={() =>
                                                    getActionsAdressePrincipale(
                                                        responsableLegal,
                                                        responsableLegal.uuid,
                                                    )
                                                }
                                            />
                                            <TableAdressesComponent
                                                labelTableau="Adresse(s) secondaire(s)"
                                                listeAdresses={getAdressesSecondaires(
                                                    responsableLegal,
                                                )}
                                                listeId={getIdAdressesSecondaires(responsableLegal)}
                                                actions={(idAdresse) =>
                                                    getActionsAdressesSecondaires(
                                                        idAdresse,
                                                        responsableLegal.uuid,
                                                    )
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <ButtonGroup equisized align="right" inline iconPosition="left">
                                        <Button
                                            name="modifierInformationsResponsableLegal"
                                            variant="secondary"
                                            onClick={() => {
                                                history.push(
                                                    getPath(RoutesModifierResponsableLegal),
                                                );
                                            }}
                                        >
                                            Modifier les informations du responsable légal{' '}
                                        </Button>
                                        <Button
                                            name="ajouterAdresseSecondaireRL"
                                            onClick={() => {
                                                history.push(
                                                    getPath(RoutesAjoutAdresseSecondaire),
                                                    {
                                                        uniquidPersonnePhysique:
                                                            responsableLegal.uuid,
                                                    },
                                                );
                                            }}
                                            variant="secondary"
                                            icon="fr-icon-add-line"
                                            iconPosition="left"
                                        >
                                            Ajouter une adresse de résidence secondaire{' '}
                                        </Button>
                                    </ButtonGroup>
                                </CardContent>
                            </CardBody>
                        </CardV2>
                    </Col>
                </Row>
            )}

            <Row className="margin-top-md">
                <Col col={12}>
                    <CardV2 noEnlargeLink>
                        <CardBody>
                            <CardContent>
                                <Row gutters>
                                    <Col lg={4}>
                                        <h2>Informations du compte</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        Identifiant de connexion :{' '}
                                        {dataCompteUsager.compte.username}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        N°<abbr>SIA</abbr> :{' '}
                                        {dataCompteUsager.personnePhysique.numeroSia}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={12}>
                                        Type de compte :{' '}
                                        <TypeCompte typesCompte={dataCompteUsager.typeCompte} />
                                    </Col>
                                </Row>

                                {dataCompteUsager.personnePhysique.carteCollectionneur && (
                                    <>
                                        <Row>
                                            <Col lg={12}>
                                                N° de carte de collectionneur :{' '}
                                                {
                                                    dataCompteUsager.personnePhysique
                                                        .carteCollectionneur.numero
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                Date de fin de validité de la carte de
                                                collectionneur :{' '}
                                                {
                                                    dataCompteUsager.personnePhysique
                                                        .carteCollectionneur.dateFinValidite
                                                }
                                            </Col>
                                        </Row>
                                        {dataCompteUsager.personnePhysique.carteCollectionneur
                                            .fichier && (
                                            <Row>
                                                <Col col={12}>
                                                    <DisplayLicence
                                                        type="Carte de collectionneur "
                                                        aria-label="Télécharger la carte de collectionneur"
                                                        fichier={
                                                            dataCompteUsager.personnePhysique
                                                                .carteCollectionneur.fichier
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}

                                {isMineurNonEmancipe && (
                                    <Row>
                                        <Col lg={12}>
                                            Émancipé :{' '}
                                            {dataCompteUsager.mineurEmancipe === true
                                                ? 'Oui'
                                                : 'Non'}
                                        </Col>
                                    </Row>
                                )}

                                {isMetierPhysique(sousStatut) && (
                                    <Row>
                                        <Col lg={12}>
                                            Type de métier :{' '}
                                            {
                                                dataCompteUsager.informationsMetiersAssociations
                                                    .typeMetier
                                            }
                                        </Col>
                                    </Row>
                                )}

                                {!sousStatut && (
                                    <Row>
                                        <Col lg={12}>
                                            Compétiteur :{' '}
                                            {dataCompteUsager.personnePhysique
                                                .attestationCompetiteur
                                                ? 'Oui'
                                                : 'Non'}
                                        </Col>
                                    </Row>
                                )}

                                {dataCompteUsager.licences.licenceTir &&
                                    !dataCompteUsager.licences.licenceTir.isAncienLicencie && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° de licence de Tir"
                                                    aria-label="Télécharger la licence de Tir"
                                                    numero={
                                                        dataCompteUsager.licences.licenceTir?.numero
                                                    }
                                                    fichier={
                                                        isFeatureActive(
                                                            featureFlipping,
                                                            FEATURE_APPEL_API_FFTIR,
                                                        )
                                                            ? undefined
                                                            : dataCompteUsager.licences.licenceTir
                                                                  ?.licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.licences.licenceBallTrap &&
                                    !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° de licence de Ball-Trap"
                                                    aria-label="Télécharger la licence de Ball-Trap"
                                                    numero={
                                                        dataCompteUsager.licences.licenceBallTrap
                                                            ?.numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.licenceBallTrap
                                                            ?.licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.licences.licenceSki &&
                                    !dataCompteUsager.licences.licenceSki.isAncienLicencie && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° de licence de Ski"
                                                    aria-label="Télécharger la licence de Ski"
                                                    numero={
                                                        dataCompteUsager.licences.licenceSki?.numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.licenceSki
                                                            ?.licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.licences.permisChasser && (
                                    <>
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° de permis de chasser "
                                                    aria-label="Télécharger le permis de chasser"
                                                    numero={
                                                        dataCompteUsager.licences.permisChasser
                                                            .numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.permisChasser
                                                            .permisChasserFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        {dataCompteUsager.licences.permisChasser
                                            .numeroGuichetUnique && (
                                            <Row>
                                                <Col col={12}>
                                                    <DisplayLicence
                                                        type="N° de guichet unique "
                                                        aria-label="Télécharger la validation de permis de chasser"
                                                        numero={
                                                            dataCompteUsager.licences.permisChasser
                                                                .numeroGuichetUnique
                                                        }
                                                        fichier={
                                                            dataCompteUsager.licences.permisChasser
                                                                .validationPermisChasserFichier
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}

                                {dataCompteUsager.licences.licenceTir &&
                                    dataCompteUsager.licences.licenceTir.isAncienLicencie &&
                                    dataCompteUsager.licences.licenceTir.numero && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° ancienne licence de Tir"
                                                    aria-label="Télécharger l'ancienne licence de Tir"
                                                    numero={
                                                        dataCompteUsager.licences.licenceTir.numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.licenceTir
                                                            .licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.licences.licenceBallTrap &&
                                    dataCompteUsager.licences.licenceBallTrap.isAncienLicencie &&
                                    dataCompteUsager.licences.licenceBallTrap.numero && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° ancienne licence de Ball-Trap"
                                                    aria-label="Télécharger l'ancienne licence de Ball-Trap"
                                                    numero={
                                                        dataCompteUsager.licences.licenceBallTrap
                                                            .numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.licenceBallTrap
                                                            .licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.licences.licenceSki &&
                                    dataCompteUsager.licences.licenceSki.isAncienLicencie &&
                                    dataCompteUsager.licences.licenceSki.numero && (
                                        <Row>
                                            <Col col={12}>
                                                <DisplayLicence
                                                    type="N° ancienne licence de Ski"
                                                    aria-label="Télécharger l'ancienne licence de ski"
                                                    numero={
                                                        dataCompteUsager.licences.licenceSki.numero
                                                    }
                                                    fichier={
                                                        dataCompteUsager.licences.licenceSki
                                                            .licenceFichier
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                {dataCompteUsager.personnePhysique.attestationCompetiteur && (
                                    <Row>
                                        <Col col={12}>
                                            Attestation de compétition FFTir :{' '}
                                            <BoutonTelechargementFichier
                                                libelle={
                                                    dataCompteUsager.personnePhysique
                                                        .attestationCompetiteur.filename
                                                }
                                                uuidFichier={
                                                    dataCompteUsager.personnePhysique
                                                        .attestationCompetiteur.uuid
                                                }
                                                id={`fichier_${dataCompteUsager.personnePhysique.attestationCompetiteur.filename}`}
                                                aria-label="Télécharger l'attestation de compétition FFTir'"
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {dataCompteUsager.personnePhysique.certificatMedicalARS && (
                                    <Row>
                                        <Col col={12}>
                                            <DisplayLicence
                                                type="Certificat médical "
                                                fichier={
                                                    dataCompteUsager.personnePhysique
                                                        .certificatMedicalARS
                                                }
                                                aria-label="Télécharger le Certificat médical"
                                            />
                                        </Col>
                                    </Row>
                                )}
                                <Row className="margin-top-lg">
                                    <Col col={12}>
                                        <ButtonGroup
                                            equisized
                                            align="left"
                                            inline="sm"
                                            iconPosition="left"
                                        >
                                            {dataCompteUsager?.informationsMetiersAssociations
                                                ?.hasPersonneMorale && (
                                                <ButtonLink
                                                    as={Link}
                                                    to={getPath(
                                                        RoutesMonCompte.subroutes.listeEmployes,
                                                    )}
                                                    variant="secondary"
                                                >
                                                    Gestion des comptes employés
                                                </ButtonLink>
                                            )}
                                            <ButtonLink
                                                as={Link}
                                                to={getPath(
                                                    RoutesMonCompte.subroutes
                                                        .modifierInformationsCompte,
                                                )}
                                                variant="secondary"
                                            >
                                                {isMineurNonEmancipe
                                                    ? 'Modifier les informations du compte mineur'
                                                    : 'Modifier les informations de mon compte'}
                                            </ButtonLink>
                                            <ButtonLink
                                                as={Link}
                                                to={getPath(
                                                    RoutesMonCompte.subroutes.changementMotDePasse,
                                                )}
                                                variant="secondary"
                                            >
                                                Changer de mot de passe
                                            </ButtonLink>
                                            <ButtonLink
                                                as={Link}
                                                to={getPath(
                                                    RoutesMonCompte.subroutes
                                                        .modifierQuestionsReponses,
                                                )}
                                                variant="secondary"
                                            >
                                                Changer de questions/réponses secrètes
                                            </ButtonLink>{' '}
                                            {isFeatureActive(
                                                featureFlipping,
                                                FEATURE_MFA_DETENTEUR_PREFECTURE,
                                            ) && (
                                                <a
                                                    href={`${process.env.REACT_APP_KEYCLOAK_ACCOUNT_URL}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="fr-btn fr-btn--secondary"
                                                >
                                                    Gestion du 2ième facteur d'authentification
                                                </a>
                                            )}
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardContent>
                        </CardBody>
                    </CardV2>
                </Col>
            </Row>
            <Row className="margin-top-md">
                <Col col={12}>
                    <ButtonLink
                        as={Link}
                        to={URL_RATELIER}
                        variant="secondary"
                        aria-label="Retour à mon râtelier"
                    >
                        Retour
                    </ButtonLink>
                </Col>
            </Row>
        </Container>
    );
};

EcranGestion.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataCompteUsager: PropTypes.shape({
        compte: PropTypes.shape({
            dateDeCreation: PropTypes.string.isRequired,
            username: PropTypes.string.isRequired,
        }).isRequired,
        personnePhysique: PropTypes.shape({
            numeroSia: PropTypes.string.isRequired,
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            prenomDeux: PropTypes.string,
            prenomTrois: PropTypes.string,
            prenomQuatre: PropTypes.string,
            prenomUsuel: PropTypes.string.isRequired,
            sexe: PropTypes.string,
            dateNaissance: PropTypes.string,
            lieuNaissance: PropTypes.string,
            codePostalNaissance: PropTypes.string,
            paysNaissance: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            nationalite: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            telephonePrincipal: PropTypes.string,
            telephoneSecondaire: PropTypes.string,
            mail: PropTypes.string,
            adressePrincipale: PropTypes.shape({
                id: PropTypes.number,
                numeroVoie: PropTypes.string,
                extension: PropTypes.string,
                libelleVoie: PropTypes.string,
                lieuDit: PropTypes.string,
                codePostal: PropTypes.string,
                ville: PropTypes.string,
                pays: PropTypes.shape({
                    libelle: PropTypes.string.isRequired,
                }).isRequired,
                justificatifsDomicile: PropTypes.shape({
                    fichiers: PropTypes.arrayOf({
                        uuid: PropTypes.string.isRequired,
                        filename: PropTypes.string.isRequired,
                    }),
                }),
            }).isRequired,
            adressesSecondaires: PropTypes.arrayOf(
                shape({
                    id: PropTypes.number,
                    adresseInternationale: PropTypes.string,
                    numeroVoie: PropTypes.string,
                    extension: PropTypes.string,
                    libelleVoie: PropTypes.string,
                    lieuDit: PropTypes.string,
                    codePostal: PropTypes.string,
                    ville: PropTypes.string,
                    pays: PropTypes.shape({
                        libelle: PropTypes.string.isRequired,
                    }).isRequired,
                }),
            ).isRequired,
            pieceIdentite: PropTypes.shape({
                typePieceIdentite: PropTypes.string,
                numeroPieceIdentite: PropTypes.string,
                piecesIdentiteFichier: PropTypes.arrayOf(
                    PropTypes.shape({
                        uuid: PropTypes.string.isRequired,
                        filename: PropTypes.string.isRequired,
                    }),
                ),
            }),
            certificatMedicalARS: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
            attestationCompetiteur: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
            carteCollectionneur: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                dateFinValidite: PropTypes.string,
                fichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
        }).isRequired,
        licences: PropTypes.shape({
            permisChasser: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                numeroGuichetUnique: PropTypes.string.isRequired,
                permisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                validationPermisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceTir: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                isAncienLicencie: PropTypes.bool.isRequired,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceBallTrap: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
            licenceSki: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
        }),
        hasInjonctionPrefectorale: PropTypes.bool.isRequired,
        typeCompte: PropTypes.string.isRequired,
        informationsMetiersAssociations: PropTypes.shape({
            hasPersonneMorale: PropTypes.bool,
            etablissement: PropTypes.object,
            typeFederation: PropTypes.string,
            typeMetier: PropTypes.string,
            documents: PropTypes.shape({
                permisDeChasse: PropTypes.object,
                autorisationDetentionArme: PropTypes.object,
                autorisationExerciceCnaps: PropTypes.object,
                autorisationExerciceAfci: PropTypes.object,
            }),
            adresseEtablissement: PropTypes.object,
            adressesSecondairesEtablissement: PropTypes.array,
            titresDetention: PropTypes.shape({
                declarations: PropTypes.array,
                autorisations: PropTypes.array,
            }),
            employes: PropTypes.array,
            sousStatut: PropTypes.string,
        }),
        mineurEmancipe: PropTypes.bool,
        responsableLegal: PropTypes.object,
    }),
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    message: PropTypes.string,
    dataSuppression: PropTypes.shape,
};

export default connect(
    (state) => {
        const { isLoading, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            data: dataSuppression,
            erreur,
            message,
        } = state.monCompte.suppressionAdresseSecondaire;
        return {
            isLoading,
            dataCompteUsager,
            erreur,
            message,
            dataSuppression,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(EcranGestion);
